import { A11yModule } from '@angular/cdk/a11y';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule } from '@angular/router';
import { UiLineChartModule } from '@components/ui-chart/line/ui-line-chart.module';
import { UiToggleSwitchModule } from '@components/ui-toggle-switch/ui-toggle-switch.module';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { FileSizePipe } from '@pipes/file-size.pipe';
import { ChartColorService } from '@services';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiSuggestModule } from '@uipath/angular/components/ui-suggest';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiDragAndDropModule } from '@uipath/angular/directives/ui-drag-and-drop-file';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiSecondFormatModule } from '@uipath/angular/directives/ui-secondformat';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { PapaParseModule } from 'ngx-papaparse';

import {
    BulkAddItemsModalComponent,
    TransactionChartModalComponent,
} from './modals';
import { QueuesPageComponent } from './queues.page';
import { QueueUpsertModule } from './upsert/queue.upsert.module';

const MODALS = [
    TransactionChartModalComponent,
    BulkAddItemsModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,
        UiToggleSwitchModule,
        UiLineChartModule,
        PapaParseModule,
        MatExpansionModule,
        UiGridModule,
        UiGridResetModule,
        UiSuggestModule,
        A11yModule,
        UiNgLetModule,
        UiAutofocusModule,
        UiDragAndDropModule,
        UiSecondFormatModule,
        QueueUpsertModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
    ],
    providers: [
        FileSizePipe,
        ChartColorService,
    ],
    declarations: [
        QueuesPageComponent,
        ...MODALS,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class QueueModule { }
